/**
 * Data columns of the process table, in render order. Drives both the header row
 * and {@link COLUMN_COUNT}, so adding a column needs no other edit here.
 */
export const PROCESS_DATA_COLUMNS = [
  "Processing Name",
  "Processing Type",
  "Facility",
  "Capacity (input/hr)",
  "Input",
  "Output",
  "Bio waste/side stream",
  "Electricity (per input)",
  "Water (per input)",
  "Heat (per input)"
] as const;

/** Leading chevron column + the data columns + trailing Actions column. */
export const COLUMN_COUNT = PROCESS_DATA_COLUMNS.length + 2;

/** Column index from which the header/cell content is right-aligned. */
export const FIRST_RIGHT_ALIGNED_COLUMN = 3;
